import styled from 'styled-components';
import { getTextColor, themeGet } from '@magalu/stereo-ui-styles';
import Input from '../../atoms/Input';
import Button from '../../atoms/Button';
export const StyledInput = styled(Input)`
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  color: ${props => getTextColor('scratched')(props)};
  height: 52px;
`;
export const StyledButton = styled(Button)`
  align-items: center;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  display: flex;
  flex-direction: column;
  font-size: ${props => themeGet('fontSizes.0')(props)}px;
  height: 52px;
  min-width: 64px;
  padding: ${props => themeGet('space.1')(props)}px;
`;